<template>
  <div
    class="loading-spinner"
    :class="{ 'loading-spinner--overlay': overlay }"
  >
    <div class="loading-spinner__content">
      <div
        class="spinner-border text-primary"
        role="status"
      >
      </div>
      <div
        v-if="message"
        class="loading-spinner__message mt-2"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  &--overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
  }

  &__content {
    text-align: center;
  }

  &__message {
    color: #6c757d;
    font-size: 0.875rem;
  }
}
</style> 
